import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const MessageRoot = superstyled({
  name: 'Message',
  slot: 'Root',
  tag: Box,
  propsNeeded: ['variant'],
  styles: ({ theme, variant }) => ({
    marginBottom: theme.spacing(1),
    ...(variant === 'card' && {
      backgroundColor: theme.palette.background.grey.light,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(3),
      border: `1px solid ${theme.palette.border.main}`
    })
  })
});

export const MessageContent = superstyled({
  name: 'Message',
  slot: 'Content',
  tag: Box,
  styles: () => ({
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px'
  })
});

export const MessageText = superstyled({
  name: 'MessageText',
  slot: 'Text',
  tag: Text,
  styles: ({ theme }) => ({
    whiteSpace: 'pre-wrap',
    flex: 1,
    '& > * + *': {
      marginTop: theme.spacing(1)
    }
  })
});

export const CopyButton = superstyled({
  name: 'Message',
  slot: 'CopyButton',
  tag: 'button',
  styles: ({ theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    borderRadius: '4px',
    transition: 'all 0.2s ease-in-out',
    flexShrink: 0,
    marginTop: '2px',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.text.primary
    },
    '&:focus': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: '2px'
    },
    '&:active': {
      backgroundColor: theme.palette.action.selected
    }
  })
});
